import { render, staticRenderFns } from "./GraphHerbicides.vue?vue&type=template&id=ffff0b74&"
import script from "./GraphHerbicides.vue?vue&type=script&lang=js&"
export * from "./GraphHerbicides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports